export default "__VITE_ASSET__FfRs6Qs3__"